import React from 'react'
import PropType from 'prop-types'
import Lib from '../../loader'

function Media({
  children, className, title, image, clickHandler,
}) {
  return (
    <Lib.CardMedia className={className} image={image} title={title} onClick={clickHandler}>
      { children }
    </Lib.CardMedia>
  )
}

Media.defaultProps = {
  children: null,
  className: '',
  image: '',
  title: '',
  clickHandler: undefined,
}

Media.propTypes = {
  children: PropType.node,
  className: PropType.string,
  image: PropType.string,
  title: PropType.string,
  clickHandler: PropType.func,
}

export default Media
